export const LIST_BANK_FIELDS_REQUEST = "LIST_BANK_FIELDS_REQUEST";
export const LIST_BANK_FIELDS_SUCCESS = "LIST_BANK_FIELDS_SUCCESS";
export const LIST_BANK_FIELDS_FAILED = "LIST_BANK_FIELDS_FAILED";
